import React, { useState } from 'react'
import { Play, Loader2 } from 'lucide-react'

// Tải Pyodide 1 lần (cache toàn cục) — chạy Python trong trình duyệt.
const PYODIDE_VER = 'v0.26.4'
function getPyodide(): Promise<any> {
  const w = window as any
  if (w.__pyodidePromise) return w.__pyodidePromise
  w.__pyodidePromise = (async () => {
    if (!w.loadPyodide) {
      await new Promise<void>((res, rej) => {
        const s = document.createElement('script')
        s.src = `https://cdn.jsdelivr.net/pyodide/${PYODIDE_VER}/full/pyodide.js`
        s.onload = () => res()
        s.onerror = () => rej(new Error('Không tải được Pyodide'))
        document.head.appendChild(s)
      })
    }
    return w.loadPyodide({ indexURL: `https://cdn.jsdelivr.net/pyodide/${PYODIDE_VER}/full/` })
  })()
  return w.__pyodidePromise
}

const PyodideRunner: React.FC<{ code: string }> = ({ code }) => {
  const [status, setStatus] = useState<'idle' | 'loading' | 'running' | 'done' | 'error'>('idle')
  const [output, setOutput] = useState('')
  const [img, setImg] = useState('')
  const [err, setErr] = useState('')

  const run = async () => {
    setErr('')
    setOutput('')
    setImg('')
    setStatus('loading')
    try {
      const py = await getPyodide()
      const usesMpl = /matplotlib|pyplot|\bplt\b/.test(code)
      if (usesMpl || /numpy|\bnp\b/.test(code)) {
        await py.loadPackage(['numpy', 'matplotlib'])
      }
      setStatus('running')
      py.runPython('import sys, io\nsys.stdout = io.StringIO()')
      if (usesMpl) py.runPython("import matplotlib\nmatplotlib.use('Agg')")
      await py.runPythonAsync(code)
      const out = py.runPython('sys.stdout.getvalue()') as string
      setOutput(out || '')
      if (usesMpl) {
        const b64 = py.runPython(`
import io, base64
_b=''
try:
    import matplotlib.pyplot as plt
    if plt.get_fignums():
        _buf=io.BytesIO(); plt.savefig(_buf, format='png', dpi=110, bbox_inches='tight'); _buf.seek(0)
        _b=base64.b64encode(_buf.read()).decode()
        plt.close('all')
except Exception:
    _b=''
_b
`) as string
        if (b64) setImg(`data:image/png;base64,${b64}`)
      }
      setStatus('done')
    } catch (e) {
      setErr((e as Error)?.message || String(e))
      setStatus('error')
    }
  }

  return (
    <div className="space-y-3">
      <button
        onClick={run}
        disabled={status === 'loading' || status === 'running'}
        className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-violet-600 text-white text-sm font-bold hover:bg-violet-700 disabled:opacity-60"
      >
        {status === 'loading' || status === 'running' ? <Loader2 size={16} className="animate-spin" /> : <Play size={16} />}
        {status === 'loading' ? 'Đang tải Python...' : status === 'running' ? 'Đang chạy...' : 'Chạy mô phỏng'}
      </button>

      {err && <pre className="text-xs text-red-600 bg-red-50 border border-red-100 rounded-lg p-3 whitespace-pre-wrap">{err}</pre>}
      {img && <img src={img} alt="Kết quả mô phỏng" className="w-full rounded-lg border border-gray-200" />}
      {output && <pre className="text-xs bg-gray-900 text-gray-100 rounded-lg p-3 overflow-x-auto whitespace-pre-wrap">{output}</pre>}
      {status === 'loading' && <p className="text-[11px] text-gray-400">Lần đầu tải Python (~vài MB), các lần sau nhanh hơn.</p>}
    </div>
  )
}

export default PyodideRunner
